
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { InventoryTransactionListItem } from "@/models/api/barcodeSystem/inventory/inventoryTransactions";
import { formatDateWithTime, formatBool } from "@/utils";

const inventoryModuleState = getModule(InventoryModule);

@Component
export default class InventoryTranactionTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get inventoryTransactions(): Array<InventoryTransactionListItem> {
    return inventoryModuleState.transData;
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  onRowClick(data) {
  }

  unselectAll() {
  }
}
